module.exports = __webpack_public_path__ + "static/img/patho-material-Bv3vzH20.6503660d.png";